import _ from 'underscore';
import { createSelector } from 'reselect';

const isNodeExpanded = node => node.state && node.state.expanded;
const nodeHasChildren = node => node.children && node.children.length;

export const getFlattenedTree = (nodes, parents = []) =>
  nodes.reduce((flattenedTree, node) => {
    const deepness = parents.length;
    const nodeWithHelpers = _.extend(node, { deepness, parents });

    if (!nodeHasChildren(node) || !isNodeExpanded(node)) {
      return [...flattenedTree, nodeWithHelpers];
    }

    return [
      ...flattenedTree,
      nodeWithHelpers,
      ...getFlattenedTree(node.children, [...parents, node.id]),
    ];
  }, []);

export const getRowIndexFromId = (flattenedTree, id) =>
  _.findIndex(flattenedTree, node => node.id === id);

export const getExtensions = createSelector(
  e => e,
  (extensions = {}) => {
    const { updateTypeHandlers = {} } = extensions;

    return { updateTypeHandlers };
  }
);

export const getNodeRenderOptions = createSelector(
  node => (node.state || {}).expanded,
  node => node.iconHidden,
  node => node.isExpandable,
  node => node.children,
  (expanded, iconHidden, isExpandable, children = []) => ({
    hasChildren: !!children.length,
    isExpanded: !!expanded,
    isIconHidden: !!iconHidden,
    isExpandable: isExpandable || !!children.length,
  })
);

// input: nodes: all nodes, filterNode: function for filtering
// Output: List of node IDs that are search results.
// Misc: Changes node expand state
export const setNodeExpandState = (nodes, filterNode, isSearch = true) => {
  const nodeIds = [];
  // currentNode is the currently searched node.
  // returns a true or false.
  const searchFilterLoop = (currentNode) => {
    let returnVar;

    // First check if this node has the searched term.
    // Include if it does
    returnVar = !!filterNode(currentNode);

    if (nodeHasChildren(currentNode)) {
      // First check if any children nodes meet search query.
      _.each(currentNode.children, (e) => {
        returnVar = searchFilterLoop(e) || returnVar;
      });
      // Expand any nodes that meet the query, collapse any that do not.
      if (isSearch) {
        // eslint-disable-next-line no-param-reassign
        currentNode.state = { ...currentNode.state, ...{ expanded: returnVar } };
      }
    }
    if (returnVar) {
      nodeIds.push(currentNode.id);
    }
    return returnVar;
  };

  _.each(nodes, e => searchFilterLoop(e));

  return nodeIds;
};
